"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iris_1 = require("iris");
var lodash_1 = require("lodash");
var invalidCodes = ['', 'NOFLIGHT', 'SZG', 'VIE', 'ZRH'];
var defaultCodes = ['', 'NOFLIGHT'];
var priceModelsRnf = ['PREMIUM', 'PREMIUMAI'];
// return the current state
function state(state) {
    return state;
}
exports.state = state;
// outgoing flight is wanted
function outgoingFlightIsActivated(state) {
    return state.outgoingSelection.activated;
    // return state.outgoingSelection.selected !== 'NOFLIGHT'
}
exports.outgoingFlightIsActivated = outgoingFlightIsActivated;
// outgoing flight is wanted
function returningFlightIsActivated(state) {
    return state.returningSelection.activated;
    // return state.returningSelection.selected !== 'NOFLIGHT'
}
exports.returningFlightIsActivated = returningFlightIsActivated;
// are there possible outgoing flights at all?
function outgoingFlightIsPossible(state) {
    return state.outgoingSelection.enabled;
}
exports.outgoingFlightIsPossible = outgoingFlightIsPossible;
// are there possible returning flights at all?
function returningFlightIsPossible(state) {
    return state.returningSelection.enabled;
}
exports.returningFlightIsPossible = returningFlightIsPossible;
// which request has fired last?
function lastFetchRequestKey(state) {
    return state.loading;
}
exports.lastFetchRequestKey = lastFetchRequestKey;
// which code has been selected
function outgoingSelectionCode(state) {
    return state.outgoingSelection.selected;
}
exports.outgoingSelectionCode = outgoingSelectionCode;
// which code has been selected
function returningSelectionCode(state) {
    return state.returningSelection.selected;
}
exports.returningSelectionCode = returningSelectionCode;
// return the ready-made list usable for select-fields with {name, value, price}
function outgoingAirports(state) {
    var outClass = outgoingFlightClass(state);
    var returnIsActivated = returningFlightIsActivated(state);
    var outgoingIsActivated = outgoingFlightIsActivated(state);
    var flights = state.flights ? state.flights.getOutgoingAirports(outClass, returnIsActivated, state.roundtripsOnly) : null;
    if (state.withOutNoFlight) {
        flights = lodash_1.concat(new Array({ code: 'NOFLIGHT', name: 'Kein Hinflug' }), lodash_1.sortBy(flights, 'name'));
    }
    else {
        flights = lodash_1.sortBy(flights, 'name');
    }
    return flights;
}
exports.outgoingAirports = outgoingAirports;
// return the ready-made list usable for select-fields with {name, value, price}
function returningAirports(state) {
    var retClass = returningFlightClass(state);
    var outgoingIsActivated = outgoingFlightIsActivated(state);
    var returnIsActivated = returningFlightIsActivated(state);
    var withTwoWay = outgoingIsActivated && returnIsActivated;
    var outCode = outgoingSelectionCode(state);
    var flights = state.flights ? state.flights.getReturningAirports(retClass, withTwoWay, outCode, state.roundtripsOnly) : null;
    if (flights && flights.length === 1) {
        if (state.flights.isMandatoryRoundTrip()) {
            return flights;
        }
        var outFlights = state.flights.getOutgoingAirports(retClass, false, state.roundtripsOnly);
        var twoWay = false;
        if (outFlights && outFlights.length === 0) {
            twoWay = true;
        }
        var retFlights = state.flights.getReturningAirports(retClass, twoWay, outCode, state.roundtripsOnly);
        if (retFlights && retFlights.length === 1) {
            if (state.withRetNoFlight) {
                flights = lodash_1.concat(new Array({ code: 'NOFLIGHT', name: 'Kein Rückflug' }), lodash_1.sortBy(flights, 'name'));
            }
            else {
                flights = lodash_1.sortBy(flights, 'name');
            }
            return flights;
        }
        var valid_1 = lodash_1.find(outFlights, function (item) {
            return item.code === outCode;
        });
        if (retFlights && retFlights.length < 1 && !valid_1) {
            if (state.withRetNoFlight) {
                flights = lodash_1.concat(new Array({ code: 'NOFLIGHT', name: 'Kein Rückflug' }), lodash_1.sortBy(flights, 'name'));
            }
            else {
                flights = lodash_1.sortBy(flights, 'name');
            }
            return flights;
        }
    }
    if (state.withRetNoFlight) {
        flights = lodash_1.concat(new Array({ code: 'NOFLIGHT', name: 'Kein Rückflug' }), lodash_1.sortBy(flights, 'name'));
    }
    else {
        flights = lodash_1.sortBy(flights, 'name');
    }
    return flights;
}
exports.returningAirports = returningAirports;
// which AirConnection is selected?
function selectedConnection(state) {
    var outCode = outgoingSelectionCode(state);
    var retCode = returningSelectionCode(state);
    var flightClass = outgoingFlightClass(state);
    return state.flights ? state.flights.getSelectedConnection(flightClass, outCode, retCode) : null;
}
exports.selectedConnection = selectedConnection;
// return a detailed information about the selected outgoing flight
function displayOutgoingFlight(state) {
    var conn = selectedConnection(state);
    if (conn) {
        return conn.displayOutgoing();
    }
    else {
        return null;
    }
}
exports.displayOutgoingFlight = displayOutgoingFlight;
// return a detailed information about the selected returning flight
function displayReturningFlight(state) {
    var conn = selectedConnection(state);
    if (conn) {
        return conn.displayReturning();
    }
    else {
        return null;
    }
}
exports.displayReturningFlight = displayReturningFlight;
// is this flight a mandatory roundtrip ?
function isMandatoryRoundtrip(state) {
    return state.mandatoryRoundtrip;
}
exports.isMandatoryRoundtrip = isMandatoryRoundtrip;
// list of outgoing flight classes
function outgoingFlightClasses(state) {
    return state.flights.flightClasses;
}
exports.outgoingFlightClasses = outgoingFlightClasses;
// list of outgoing flight classes, same as outgoing!
function returningFlightClasses(state) {
    return state.flights.flightClasses;
}
exports.returningFlightClasses = returningFlightClasses;
// what is the selected flight class?
function outgoingFlightClass(state) {
    var flightClass = state.outgoingSelection.flightClass;
    if (flightClass) {
        return flightClass;
    }
    else {
        return '';
    }
}
exports.outgoingFlightClass = outgoingFlightClass;
// what is the selected flight class?
function returningFlightClass(state) {
    return outgoingFlightClass(state);
}
exports.returningFlightClass = returningFlightClass;
// is the chosen selection valid?
function valid(state) {
    var outgoingIsActivated = outgoingFlightIsActivated(state);
    var returnIsActivated = returningFlightIsActivated(state);
    var outCode = outgoingSelectionCode(state);
    var retCode = returningSelectionCode(state);
    if (!outgoingIsActivated && !returnIsActivated) {
        return false;
    }
    if (outgoingIsActivated && returnIsActivated && (!retCode || !outCode)) {
        return false;
    }
    if (outgoingIsActivated && !outCode && returnIsActivated && !retCode) {
        return false;
    }
    if (outgoingIsActivated && outCode === 'NOFLIGHT' && returnIsActivated && retCode === 'NOFLIGHT') {
        return false;
    }
    if (totalPrice(state) === 0) {
        return false;
    }
    return true;
}
exports.valid = valid;
// calculate the total price of the chosen flights
function totalPrice(state) {
    var differ = priceDiffer(state);
    if (differ && differ !== 0) {
        return differ;
    }
    var conn = selectedConnection(state);
    if (conn) {
        return conn.totalPrice();
    }
    return 0;
}
exports.totalPrice = totalPrice;
// returns the priceDiffer from state
function currentPriceDiffer(state) {
    return state.priceDiffer;
}
exports.currentPriceDiffer = currentPriceDiffer;
// returns the price of the selected connection - call to compare to priceDiffer !
function selectedConnPrice(state) {
    var conn = selectedConnection(state);
    if (conn) {
        return conn.totalPrice();
    }
    return 0;
}
exports.selectedConnPrice = selectedConnPrice;
function getOutRetCombos(outgoing, returning) {
    var list = [];
    lodash_1.forEach(outgoing, function (outFlight) {
        lodash_1.forEach(returning, function (retFlight) {
            var outFlightClone = lodash_1.cloneDeep(outFlight);
            outFlightClone[0].returnFlight = retFlight[0].returnFlight;
            list = lodash_1.concat(list, new Array(outFlightClone));
        });
    });
    return list;
}
// finds the lowest price flight
function lowestPriceFlight(state) {
    var lowestPrice = Number.POSITIVE_INFINITY;
    var lowestPriceFlight;
    var outgoingClasses = outgoingFlightClasses(state);
    if (outgoingClasses) {
        var classes = lodash_1.map(outgoingClasses, 'code');
        lodash_1.forEach(classes, function (cl) {
            var tmp;
            var list = state.flights ? state.flights.getTwoWayAirConnections(cl) : null;
            if (list && !state.roundtripsOnly) {
                // check if outoging and return flights exist and add all
                // combos to twoWay list, there might be a cheaper combo !!
                var outgoing = state.flights.getOutgoingAirConnectionsOnly(cl);
                var returning = state.flights.getReturningAirConnectionsOnly(cl);
                if (outgoing && (outgoing.length > 0) &&
                    returning && (returning.length > 0)) {
                    var comboList = getOutRetCombos(outgoing, returning);
                    if (comboList && comboList.length > 0) {
                        list = lodash_1.concat(list, lodash_1.values(comboList));
                    }
                }
            }
            if (!state.roundtripsOnly && (!list || list.length === 0)) {
                list = state.flights ? state.flights.getOutgoingAirConnectionsOnly(cl) : null;
            }
            if (!state.roundtripsOnly && (!list || list.length === 0)) {
                list = state.flights ? state.flights.getReturningAirConnectionsOnly(cl) : null;
            }
            lodash_1.forEach(list, function (flight) {
                tmp = 0;
                if (flight[0].outgoingFlight) {
                    tmp += flight[0].outgoingFlight.price;
                }
                if (flight[0].returnFlight) {
                    tmp += flight[0].returnFlight.price;
                }
                if (tmp < lowestPrice) {
                    lowestPrice = tmp;
                    lowestPriceFlight = {
                        outgoing: flight[0],
                        returning: flight[0]
                    };
                }
            });
        });
    }
    return lowestPriceFlight;
}
exports.lowestPriceFlight = lowestPriceFlight;
// return lowestPrice
function lowestPrice(state) {
    var lowestFlight = lowestPriceFlight(state);
    //    console.log('lowestPrice: ', lowestFlight)
    var lowestPrice = 0;
    if (lowestFlight &&
        lowestFlight.outgoing &&
        lowestFlight.outgoing.outgoingFlight) {
        lowestPrice += lowestFlight.outgoing.outgoingFlight.price;
    }
    if (lowestFlight &&
        lowestFlight.returning &&
        lowestFlight.returning.returnFlight) {
        lowestPrice += lowestFlight.returning.returnFlight.price;
    }
    return lowestPrice;
}
exports.lowestPrice = lowestPrice;
// calculate the current price of the chosen flights
function currentPrice(state) {
    var conn = selectedConnection(state);
    if (conn) {
        return conn.totalPrice();
    }
    return 0;
}
exports.currentPrice = currentPrice;
// gather all data required for a booking request
function transportOptionsForBooking(state) {
    var conn = selectedConnection(state);
    if (conn) {
        return conn.transportOptionsForBooking();
    }
    else {
        return [];
    }
}
exports.transportOptionsForBooking = transportOptionsForBooking;
// get a defined priceDiffer (or 0)
function priceDiffer(state) {
    return state.priceDiffer;
}
exports.priceDiffer = priceDiffer;
// get a defined priceDifference (or 0)
function priceDifference(state) {
    return state.priceDifference;
}
exports.priceDifference = priceDifference;
// returns the arrival airportname of the outgoing flights
function outgoingFlightAirport(state) {
    if (outgoingFlightIsPossible(state)) {
        var classes = outgoingFlightClasses(state);
        if (classes.length < 1) {
            return false;
        }
        var flights = state.flights ? state.flights.getOutgoingAirConnections(classes[0]['code']) : null;
        if (!flights || flights.length < 1) {
            return false;
        }
        var lastSegment = lodash_1.last(flights[0][0]['outgoingFlight']['segments']);
        return lastSegment['arrivalAirportName'];
    }
    return false;
}
exports.outgoingFlightAirport = outgoingFlightAirport;
// returns the return airport name of the return flights
function returnFlightAirport(state) {
    if (returningFlightIsPossible(state)) {
        var classes = returningFlightClasses(state);
        if (classes.length < 1) {
            return false;
        }
        var outgoingIsActivated = outgoingFlightIsActivated(state);
        var returnIsActivated = returningFlightIsActivated(state);
        var withTwoWay = outgoingIsActivated && returnIsActivated;
        var outCode = outgoingSelectionCode(state);
        var flights = state.flights ? state.flights.getReturningAirConnections(classes[0]['code'], withTwoWay, outCode) : null;
        if (!flights || flights.length < 1) {
            return false;
        }
        var lastSegment = flights[0]['returnFlight']['segments'][0];
        if (lastSegment)
            return lastSegment['departureAirportName'];
    }
    return false;
}
exports.returnFlightAirport = returnFlightAirport;
// returns state.roundtripsOnly
function roundtripsOnly(state) {
    return state.roundtripsOnly;
}
exports.roundtripsOnly = roundtripsOnly;
function flightsOutTouched(state) {
    return state.flightsOutTouched;
}
exports.flightsOutTouched = flightsOutTouched;
function flightsRetTouched(state) {
    return state.flightsRetTouched;
}
exports.flightsRetTouched = flightsRetTouched;
function rnfDeparture(state) {
    return state.rnfDeparture;
}
exports.rnfDeparture = rnfDeparture;
function rnfArrival(state) {
    return state.rnfArrival;
}
exports.rnfArrival = rnfArrival;
function rnfCategory(state) {
    return state.rnfCategory;
}
exports.rnfCategory = rnfCategory;
function rnfTotalPrice(state) {
    return state.rnfTotalPrice;
}
exports.rnfTotalPrice = rnfTotalPrice;
function rnfTransportations(state) {
    return state.rnfTransportations;
}
exports.rnfTransportations = rnfTransportations;
function rnfDirection(state) {
    if (rnfDeparture(state) && !rnfArrival(state))
        return 'O';
    if (!rnfDeparture(state) && rnfArrival(state))
        return 'R';
    if (rnfDeparture(state) && rnfArrival(state) &&
        outgoingSelectionCode(state) !== returningSelectionCode(state)) {
        return 'OJ';
    }
    return 'RT';
}
exports.rnfDirection = rnfDirection;
function validForLoadRnf(state) {
    return validForRnf(state) &&
        (rnfDeparture(state) || rnfArrival(state));
}
exports.validForLoadRnf = validForLoadRnf;
function validForRnf(state) {
    if (selectedConnection(state) === null) {
        return false;
    }
    return ((validDepartureRnf(state) && validArrivalRnf(state)) ||
        (validDepartureRnf(state) && lodash_1.includes(defaultCodes, state.returningSelection.selected)) ||
        (validArrivalRnf(state) && lodash_1.includes(defaultCodes, state.outgoingSelection.selected)));
}
exports.validForRnf = validForRnf;
function validDepartureRnf(state) {
    return !lodash_1.includes(invalidCodes, state.outgoingSelection.selected);
}
exports.validDepartureRnf = validDepartureRnf;
function validArrivalRnf(state) {
    return !lodash_1.includes(invalidCodes, state.returningSelection.selected);
}
exports.validArrivalRnf = validArrivalRnf;
function rnfIncluded(state) {
    return function (priceModel) {
        return lodash_1.includes(priceModelsRnf, priceModel) && rnfCategory(state) === iris_1.TrainClassSecond;
    };
}
exports.rnfIncluded = rnfIncluded;
// export everything compliant to the vuex specification for getters
exports.default = {
    state: state,
    outgoingFlightIsActivated: outgoingFlightIsActivated, returningFlightIsActivated: returningFlightIsActivated,
    outgoingFlightIsPossible: outgoingFlightIsPossible, returningFlightIsPossible: returningFlightIsPossible,
    lastFetchRequestKey: lastFetchRequestKey, isMandatoryRoundtrip: isMandatoryRoundtrip,
    outgoingSelectionCode: outgoingSelectionCode, returningSelectionCode: returningSelectionCode,
    outgoingAirports: outgoingAirports, returningAirports: returningAirports,
    displayOutgoingFlight: displayOutgoingFlight, displayReturningFlight: displayReturningFlight,
    valid: valid, totalPrice: totalPrice, transportOptionsForBooking: transportOptionsForBooking,
    outgoingFlightClasses: outgoingFlightClasses, returningFlightClasses: returningFlightClasses,
    outgoingFlightClass: outgoingFlightClass, returningFlightClass: returningFlightClass,
    priceDiffer: priceDiffer, selectedConnection: selectedConnection, lowestPriceFlight: lowestPriceFlight,
    lowestPrice: lowestPrice, currentPrice: currentPrice, priceDifference: priceDifference,
    outgoingFlightAirport: outgoingFlightAirport, returnFlightAirport: returnFlightAirport,
    roundtripsOnly: roundtripsOnly, currentPriceDiffer: currentPriceDiffer, selectedConnPrice: selectedConnPrice,
    flightsOutTouched: flightsOutTouched, flightsRetTouched: flightsRetTouched,
    rnfCategory: rnfCategory, rnfArrival: rnfArrival, rnfDeparture: rnfDeparture, rnfTotalPrice: rnfTotalPrice,
    rnfTransportations: rnfTransportations, rnfDirection: rnfDirection, validForLoadRnf: validForLoadRnf,
    validForRnf: validForRnf, validDepartureRnf: validDepartureRnf, validArrivalRnf: validArrivalRnf, rnfIncluded: rnfIncluded
};
//# sourceMappingURL=getters.js.map